import {
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_FAIL,
    UPDATE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_SUCCESS,
    SET_SEARCH_TERM,
    SET_SELECTED_PRODUCT_ID,
    SET_SEARCH_FIELD
} from '../actions/types';


const initialState = {
    productos: null,
    searchTerm: '',
    selectedProductId: null,
    searchField: 'equipo',
};

export default function Productos(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case GET_PRODUCTS_SUCCESS:
            return {
                ...state,
                productos: payload
            }
        case GET_PRODUCTS_FAIL:
            return {
                ...state,
                productos: null
            }
        case UPDATE_PRODUCT_SUCCESS:
            return {
                ...state,
                productos: (state.productos || []).map(producto =>
                    producto.id === payload.id ? { ...producto, ...payload } : producto
                )
            }
        case DELETE_PRODUCT_SUCCESS:
            return {
                ...state,
                productos: (state.productos || []).filter(producto => producto.id !== payload)
            }
        case SET_SEARCH_TERM:
            return {
                ...state,
                searchTerm: action.payload,
            };
        case SET_SELECTED_PRODUCT_ID:
            return {
                ...state,
                selectedProductId: action.payload,
            };
        case SET_SEARCH_FIELD:
            return {
                ...state,
                searchField: action.payload,
            };
        default:
            return state
    }
}